import {lazy} from 'react'
import {RouteObject} from 'react-router-dom'
import {AppHelmet} from '../../components/utils/AppHelmet'
import {AppLayout} from '../../components/utils/AppLayout'
import {PageSuspenseFallback} from '../../components/utils/PageSuspenseFallback'
import {AuthProtectedLayout} from '../auth/components/AuthProtectedLayout'

const UserPage = lazy(() => import('./pages/UserPage'))
const UserCreatePage = lazy(() => import('./pages/UserCreatePage'))
const UserEditPage = lazy(() => import('./pages/UserEditPage'))

export const USER_ROUTES: RouteObject[] = [
  {
    path: '/users',
    element: (
      <>
        <AppHelmet title='Users' />
        <AuthProtectedLayout adminOnly>
          <AppLayout>
            <PageSuspenseFallback>
              <UserPage />
            </PageSuspenseFallback>
          </AppLayout>
        </AuthProtectedLayout>
      </>
    ),
    children: [
      {
        path: '/users/create',
        element: (
          <>
            <AppHelmet title='User create' />
            <PageSuspenseFallback>
              <UserCreatePage />
            </PageSuspenseFallback>
          </>
        ),
      },
      {
        path: '/users/:userCode/edit',
        element: (
          <>
            <AppHelmet title='User edit' />
            <PageSuspenseFallback>
              <UserEditPage />
            </PageSuspenseFallback>
          </>
        ),
      },
    ],
  },
]
